import { Injectable } from '@angular/core';
import { CusHttp } from './CusHttp';
import { URLSearchParams } from "@angular/http";


//获取广告信息
const AD_INFO = "v1/adverts?name=";
//记录广告次数
const JUMP_AD = "v1/adverts";
@Injectable()
export class AdService {

  constructor(
    public _http: CusHttp,
  ) { }

  //获取广告信息
  getAdInfo( name: any ) {
   return this._http.get(`${AD_INFO}${name}`);
  }


 //记录广告次数
 jumpId(rowid: any) {
  let params = new URLSearchParams();
  params.append( 'id', rowid );
  return this._http.post( `${JUMP_AD}`, params );
}
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/core/services/ad.service.ts